import React, { useEffect, useState } from 'react';
import { actions } from './../../state/actions';
import { connect } from 'react-redux';
import { WithSpinner, Header } from '../../components';
import { InputWithTitle } from '../../components';
import styles from './main.module.scss';
import { config } from '../../api/config';
import { Redirect } from 'react-router-dom';
import { validateEmail, validatePhone } from './../../utils/auth/validations';
import { isEnabled } from '../../utils';

const Main = ({
  dispatch,
  loading,
  isAgreed,
  consentData,
  firstStepPassed,
  loginType,
}) => {
  // const [notValidRegistration, setNotValidRegistration] = useState(false);
  const [values, setValues] = useState({
    name: '',
    surname: '',
    company: '',
    code: '',
    email: '',
    phone: '',
    checkbox: false,
  });
  const [notValid, setNotvalid] = useState(false);
  const [agree, setAgree] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [agree3, setAgree3] = useState(false);
  const [agree4, setAgree4] = useState(false);
  const [agree5, setAgree5] = useState(false);

  const [isCompany, setIsCompany] = useState(null);

  const toggleAgree = () => {
    if (!agree === true) {
      setCheckBoxErr(false);
    }
    setAgree(!agree);
  };

  const [checkboxErr, setCheckBoxErr] = useState(false);

  const onInputChange = ({ target: { name, value } }) => {
    setValues({ ...values, [name]: value });
  };

  const confirm = () => {
    const data = {
      email: values.email,
      phone: values.phone,
      checkbox: agree,
    };
    setNotvalid(true);
    if (agree && agree1 && agree2 && agree3 && agree4 && agree5) {
      if (
        validateEmail(values.email) === null &&
        validatePhone(values.phone) === null
      ) {
        dispatch(actions.dashboard.passCompanyInfoAction(data));
      }
    } else {
      setCheckBoxErr(true);
    }
  };

  useEffect(() => {
    dispatch(actions.dashboard.getIsConsentAgreedAction());
  }, []);

  useEffect(() => {
    if (loginType === 'Individual' || loginType === 'Company')
      setIsCompany(loginType === 'Individual' ? false : true);
  }, [loginType]);

  useEffect(() => {
    if (
      consentData != null &&
      consentData.UserAuthData != null &&
      consentData.UserAuthData.FirstName != null
    ) {
      const data = consentData.UserAuthData;
      setValues({
        name: data.FirstName,
        surname: data.LastName,
        company: data.CompanyName,
        code: data.CompanyCode,
      });
    }
  }, [consentData]);

  return (
    <WithSpinner loading={loading}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className={styles.credentialsContainer}>
              <h1>Sutikimo patvirtinimas</h1>
              <div className="row imputs-content-main-window">
                <div className="col-lg-6 col-sm-12">
                  <InputWithTitle
                    name="name"
                    type="string"
                    onChange={onInputChange}
                    value={values.name}
                    placeholder="Vardas"
                    disabled={true}
                  />

                  {isCompany === true && (
                    <InputWithTitle
                      name="company"
                      type="string"
                      onChange={onInputChange}
                      value={values.company}
                      placeholder="Atstovaujamos įmonės pavadinimas"
                      disabled={true}
                    />
                  )}

                  <InputWithTitle
                    name="email"
                    type="string"
                    onChange={onInputChange}
                    value={values.email}
                    placeholder="Elektroninio pašto adresas"
                  />
                  {notValid && (
                    <p className={styles.errorsBlock}>
                      {validateEmail(values.email)}
                    </p>
                  )}
                </div>
                <div className="col-lg-6 col-sm-12">
                  <InputWithTitle
                    name="surname"
                    type="string"
                    onChange={onInputChange}
                    value={values.surname}
                    placeholder="Pavardė"
                    disabled={true}
                  />
                  {isCompany === true && (
                    <InputWithTitle
                      name="code"
                      type="string"
                      onChange={onInputChange}
                      value={values.code}
                      placeholder="Atstovaujamos įmonės kodas"
                      disabled={true}
                    />
                  )}

                  <InputWithTitle
                    name="phone"
                    type="string"
                    onChange={onInputChange}
                    value={values.phone}
                    placeholder="Telefono numeris"
                  />
                  {notValid && (
                    <p className={styles.errorsBlock}>
                      {validatePhone(values.phone, 'telefono numeris')}
                    </p>
                  )}
                </div>
              </div>

              <div className="checkbox">
                <label className="containerLabel noBlock">
                  <p>
                    <b>PRANEŠIMAS APIE ASMENS DUOMENŲ TVARKYMĄ</b>
                  </p>
                  <p>
                    1. Man yra žinoma jog UŽDAROJI AKCINĖ BENDROVĖ „INVESTICIJŲ
                    IR VERSLO GARANTIJOS“ (toliau – INVEGA), juridinio asmens
                    kodas 110084026, buveinės adresas – Konstitucijos pr. 7, LT
                    09308 Vilnius, tel. (8 5) 210 7510, el. paštas{' '}
                    <a href="mailto:info@ilte.lt">info@ilte.lt</a>, (duomenų
                    apsaugos pareigūno el. paštas{' '}
                    <a href="mailto:duomenu.apsauga@ilte.lt">
                      duomenu.apsauga@ilte.lt
                    </a>
                    ), įgyvendindama finansinę priemonę dėl kurios pateikiu
                    paraišką (toliau – Priemonė), tvarkys su Priemonės
                    įgyvendinimu susijusius paraiškoje ir jos prieduose
                    pateiktus asmens duomenis bei teisės aktų nustatytais
                    atvejais ir tvarka gautus duomenis ir informaciją iš
                    valstybės registrų ir informacinių sistemų, viešų ir
                    privačių duomenų bazių bei viešai prieinamų šaltinių.
                    <br />
                    2. Man yra žinoma, kad INVEGA, vadovaudamasi teisės aktų
                    reikalavimais, gali gauti duomenis iš kitų šaltinių:
                    Lietuvos bankas, Valstybės įmonė Registrų centras,
                    Valstybinio socialinio draudimo fondo valdyba, Valstybinė
                    mokesčių inspekciją prie LR Finansų ministerijos,
                    Informatikos ir ryšių departamentas prie LR Vidaus reikalų
                    ministerijos, Muitinės departamentas prie LR Finansų
                    ministerijos bei kitos valstybės institucijos, bendrovės,
                    tvarkančios jungtines skolininkų duomenų rinkmenas bei
                    duomenis apie kredito istoriją, įsiskolinimus (pvz., UAB
                    „Creditinfo Lietuva“), juridiniai asmenys, kai duomenys
                    teikiami apie šių juridinių asmenų atstovus, darbuotojus,
                    steigėjus, akcininkus, dalyvius, savininkus ir pan., taip
                    pat kiti viešai prieinami ir privatūs šaltiniai, kai iš jų
                    yra gaunami duomenys, reikalingi pareiškėjų, jų atstovų ir
                    dalyvių tapatybei nustatyti, pareiškėjų finansinei padėčiai
                    ir kreditingumui įvertinti, asmenų, pareiškėjų atitikčiai
                    Priemonių įgyvendinimą reglamentuojančiuose teisės aktuose
                    nustatytiems tinkamumo reikalavimams įvertinti, pareiškėjų
                    pateiktų duomenų teisingumui patikrinti bei paskolos
                    negrąžinimo, verslo subjekto, projekto rizikai įvertinti.
                    <br />
                    3. Man yra žinoma, šiame pranešime numatytais tikslais
                    INVEGA gali tvarkyti šiuos asmens duomenis:
                  </p>
                  <p style={{ marginLeft: '1rem', marginBottom: '0px' }}>
                    3.1 Kai pareiškėjas yra verslininkas (fizinis asmuo),
                    tvarkomi šie asmens duomenys: pareiškėjo vardas, pavardė,
                    asmens kodas, asmens tapatybės dokumento duomenys,
                    gyvenamosios vietos adresas, elektroninio pašto adresas,
                    telefono ryšio numeris, pilietybė, informacija apie vykdomą
                    ekonominę veiklą, galiojančio verslo liudijimo ar
                    individualios veiklos pažymos išdavimo data ir numeris,
                    faktinės veiklos vykdymo adresas, atsiskaitomosios sąskaitos
                    numeris, informacija apie asmens gaunamas pajamas paraiškos
                    pateikimo metu bei paskutinius trejus kalendorinius metus
                    iki paraiškos pateikimo dienos, paraiškos pateikimo dieną
                    turimus finansinius įsipareigojimus (informacija apie gautas
                    (suteiktas) paskolas, skolas ir kitus gautus (suteiktus)
                    kreditus), turimą registruotą kilnojamąjį ir nekilnojamąjį
                    turtą, kreditingumo istoriją, valdomų įmonių pavadinimai,
                    kapitalo ar balsavimo teisių dalis, sąsajos pagal turimus
                    sutartinius įsipareigojimus su kitais juridiniais asmenimis,
                    informacija apie svarbias viešąsias pareigas, ryšius su
                    politikoje dalyvaujančiais asmenimis, informacija apie
                    dalyvavimą teismo procesuose, bet kokia kita informaciją,
                    kurią pateiks pareiškėjas (pareiškėjo atstovas) INVEGAI ar
                    bus gauta iš kitų šaltinių teisės aktų nustatyta tvarka;
                    <br />
                    3.2. Kai pareiškėjas yra juridinis asmuo, tvarkomi šie
                    asmens duomenys: pareiškėjo atstovo ar kontaktinio asmens
                    finansavimo klausimais vardas, pavardė, elektroninio pašto
                    adresas, telefono ryšio numeris, darbovietės pavadinimas,
                    užimamos pareigos, pareiškėjo vadovo vardas, pavardė, asmens
                    kodas, pilietybė, elektroninio pašto adresas, telefono ryšio
                    numeris, informacija apie svarbias viešąsias pareigas,
                    ryšius su politikoje dalyvaujančiais asmenimis, informacija
                    apie dalyvavimą teismo procesuose, pareiškėjo dalyvių
                    vardas, pavardė, asmens kodas, pilietybė, pareiškėjo dalyvio
                    (-ių) valdomų įmonių pavadinimai, kapitalo ar balsavimo
                    teisių dalis, sąsajos pagal turimus sutartinius
                    įsipareigojimus su kitais juridiniais asmenimis, informacija
                    apie svarbias viešąsias pareigas, ryšius su politikoje
                    dalyvaujančiais asmenimis, informacija apie dalyvavimą
                    teismo procesuose, bet kokia kita informacija, kurią pateiks
                    pareiškėjas (pareiškėjo atstovas) INVEGAI ar bus gauta iš
                    kitų šaltinių teisės aktų nustatyta tvarka;
                    <br />
                    3.3. Tais atvejais, kai paskolos grąžinimas užtikrinamas
                    fizinio asmens suteikiama užtikrinimo priemone, tvarkomi
                    tokio fizinio asmens duomenys: vardas, pavardė, asmens
                    kodas, informacija apie asmens gaunamas pajamas paraiškos
                    pateikimo metu bei paskutinius trejus kalendorinius metus
                    iki paraiškos pateikimo dienos, paraiškos pateikimo dieną
                    turimus finansinius įsipareigojimus (informacija apie gautas
                    (suteiktas) paskolas, skolas ir kitus gautus (suteiktus)
                    kreditus) ir turimą registruotą kilnojamąjį ir nekilnojamąjį
                    turtą.
                    <br />
                    3.4. Tais atvejais, kai Pareiškėjo projekte dalyvauja
                    privatus finansuotojas, tvarkomi šie tokio fizinio asmens
                    duomenys:
                  </p>
                  <p style={{ marginLeft: '1rem', marginBottom: '0px' }}>
                    3.4.1. Kai privatus finansuotojas yra fizinis asmuo,
                    tvarkomi šie tokio fizinio asmens duomenys: vardas, pavardė,
                    asmens kodas, asmens tapatybės dokumento duomenys,
                    gyvenamosios vietos adresas, elektroninio pašto adresas,
                    telefono ryšio numeris, pilietybė, informacija apie vykdomą
                    ekonominę veiklą, galiojančio verslo liudijimo ar
                    individualios veiklos pažymos išdavimo data ir numeris,
                    faktinės veiklos vykdymo adresas, atsiskaitomosios sąskaitos
                    numeris, valdomų įmonių pavadinimai, kapitalo ar balsavimo
                    teisių dalis, sąsajos pagal turimus sutartinius
                    įsipareigojimus su kitais juridiniais asmenimis, informacija
                    apie svarbias viešąsias pareigas, ryšius su politikoje
                    dalyvaujančiais asmenimis, informacija apie dalyvavimą
                    teismo procesuose, bet kokia kita informaciją, kurią pateiks
                    pareiškėjas (pareiškėjo atstovas) INVEGAI ar bus gauta iš
                    kitų šaltinių teisės aktų nustatyta tvarka.
                    <br />
                    3.4.2. Kai privatus finansuotojas yra juridinis asmuo,
                    tvarkomi šie asmens duomenys: privataus finansuotojo atstovo
                    ar kontaktinio asmens finansavimo klausimais vardas,
                    pavardė, elektroninio pašto adresas, telefono ryšio numeris,
                    darbovietės pavadinimas, užimamos pareigos, privataus
                    finansuotojo vadovo vardas, pavardė, asmens kodas,
                    pilietybė, elektroninio pašto adresas, telefono ryšio
                    numeris, informacija apie svarbias viešąsias pareigas,
                    ryšius su politikoje dalyvaujančiais asmenimis, informacija
                    apie dalyvavimą teismo procesuose, privataus finansuotojo
                    dalyvių vardas, pavardė, asmens kodas, pilietybė, privataus
                    finansuotojo valdomų įmonių pavadinimai, kapitalo ar
                    balsavimo teisių dalis, sąsajos pagal turimus sutartinius
                    įsipareigojimus su kitais juridiniais asmenimis, informacija
                    apie svarbias viešąsias pareigas, ryšius su politikoje
                    dalyvaujančiais asmenimis, informacija apie dalyvavimą
                    teismo procesuose, bet kokia kita informacija, kurią pateiks
                    pareiškėjas (pareiškėjo atstovas) INVEGAI ar bus gauta iš
                    kitų šaltinių teisės aktų nustatyta tvarka.
                    <br />
                  </p>
                  <p>
                    4. Man yra žinoma, kad asmens duomenys INVEGOJE tvarkomi
                    vadovaujantis:
                  </p>
                  <p style={{ marginLeft: '1rem', marginBottom: '0px' }}>
                    4.1. 2016 m. balandžio 27 d. Europos Parlamento ir Tarybos
                    reglamento (ES) Nr. 2016/679 dėl fizinių asmenų apsaugos
                    tvarkant asmens duomenis ir dėl laisvo tokių duomenų
                    judėjimo ir kuriuo panaikinama Direktyva Nr. 95/46/EB
                    (toliau – Bendrasis duomenų apsaugos reglamentas) 6
                    straipsnio 1 dalies c punktu; 4.2. Lietuvos Respublikos
                    asmens duomenų teisinės apsaugos įstatymu;
                    <br />
                    4.3. Lietuvos Respublikos pinigų plovimo ir teroristų
                    finansavimo prevencijos įstatymu;
                    <br />
                    4.4. Lietuvos Respublikos nacionalinių plėtros įstaigų
                    įstatymo 6 str. 3 d.;
                    <br />
                    4.5. Priemonę reglamentuojančiais teisės aktais - Priemonės
                    schema (jei taikoma), Aprašu, Aprašymu;
                    <br />
                    4.6. INVEGOS generalinio direktoriaus patvirtintomis Asmens
                    duomenų tvarkymo UAB „Investicijų ir verslo garantijos“
                    taisyklėmis (toliau - INVEGOS Asmens duomenų tvarkymo
                    taisyklės). Informacija apie asmens duomenų tvarkymą
                    pateikiama INVEGOS interneto svetainės{' '}
                    <a
                      href="https://www.ilte.lt"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      www.ilte.lt
                    </a>{' '}
                    skiltyje "Asmens duomenų apsauga".
                  </p>
                  <p>
                    5. Man yra žinoma, jog asmens duomenų tvarkymo tikslas –
                    užtikrinti teisėtą valstybės pagalbos teikimą, vertinant ir
                    nustatant pareiškėjo atitiktį teisės aktų reikalavimams, ir
                    atlikti su nurodyto tikslo įgyvendinimu susijusius veiksmus:
                    tikrinti pareiškėjo pateiktos informacijos tikrumą, vykdyti
                    INVEGOS suteiktų paskolų apskaitą, INVEGOS suteiktų paskolų
                    portfelio rizikingumo vertinimą, registruoti informaciją
                    apie suteiktą valstybės pagalbą (paskolos gavėjas,
                    finansuojamas projektas, suteiktos valstybės pagalbos suma)
                    Suteiktos valstybės pagalbos ir nereikšmingos (de minimis)
                    pagalbos registre, Europos Komisijos valstybės pagalbos
                    skaidrumo viešos paieškos svetainėje{' '}
                    <a
                      href="https://webgate.ec.europa.eu/competition/transparency/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      https://webgate.ec.europa.eu/competition/transparency/
                    </a>{' '}
                    ir INVEGOS interneto svetainėje, atlikti INVEGOS suteiktų
                    paskolų auditą, o taip pat Lietuvos Respublikos teisės aktų,
                    reglamentuojančių pinigų plovimo prevenciją ir mokesčių
                    administravimą vykdymas.
                    <br />
                    6. Man yra žinoma, kad INVEGA audito tikslais ir gavusi
                    Bendrojo duomenų apsaugos reglamento reikalavimus
                    atitinkantį oficialų Europos Sąjungos ir (ar) Lietuvos
                    Respublikos institucijų (Europos Audito Rūmų, Europos
                    Komisijos, Finansų ministerijos, Ekonomikos ir inovacijų
                    ministerijos, Lietuvos Respublikos valstybės kontrolės,
                    Finansinių nusikaltimų tyrimo tarnybos prie Lietuvos
                    Respublikos vidaus reikalų ministerijos, Lietuvos
                    Respublikos specialiųjų tyrimų tarnybos, Lietuvos
                    Respublikos konkurencijos tarybos ir kitų teisėsaugos ir
                    verslo priežiūrą vykdančių institucijų) paklausimą pateikia
                    asmens duomenis kompetentingoms institucijoms.
                    <br />
                    7. Man yra žinoma, kad asmens duomenys trečiosioms
                    valstybėms nebus perduodami.
                    <br />
                    8. Man yra žinoma, kad asmens duomenys INVEGOJE tvarkomi ir
                    saugomi 10 metų nuo paskutinio dokumento pagal Priemonę
                    gavimo datos.
                  </p>
                  <p>
                    9. Patvirtinu, kad esu susipažinęs su INVEGOS interneto
                    svetainėje skelbiamomis{' '}
                    <a
                      href="https://ilte.lt/asmens-duomenu-apsauga/16"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Asmens duomenų tvarkymo INVEGOJE taisyklėmis
                    </a>
                    , man yra aiškus jų turinys.
                    <br />
                    10. Patvirtinu, kad esu supažindintas su savo, kaip duomenų
                    subjekto, teisėmis, įtvirtintomis Bendrajame duomenų
                    apsaugos reglamente:
                  </p>
                  <p style={{ marginLeft: '1rem', marginBottom: '0px' }}>
                    10.1. teise žinoti (būti informuotam) apie savo asmens
                    duomenų tvarkymą;
                    <br />
                    10.2. teise susipažinti su tvarkomais savo asmens
                    duomenimis; <br />
                    10.3. teise reikalauti ištaisyti asmens duomenis;
                    <br />
                    10.4. teise reikalauti ištrinti asmens duomenis („teisė būti
                    pamirštam“);
                    <br />
                    10.5. teise apriboti asmens duomenų tvarkymą;
                    <br />
                    10.6. teise nesutikti su asmens duomenų tvarkymu;
                    <br />
                    10.7. teise į asmens duomenų perkeliamumą.
                  </p>
                  <p>
                    11. Esu informuotas, kad duomenų subjektas turi teisę
                    pateikti skundą Valstybinei duomenų apsaugos inspekcijai,
                    jei mano, kad asmens duomenų tvarkymas atliekamas
                    pažeidžiant Bendrąjį duomenų apsaugos reglamentą. Duomenų
                    subjektas taip pat turi teisę pateikti skundą teismui, jei
                    mano, kad Bendruoju duomenų apsaugos reglamentu nustatytos
                    jo teisės buvo pažeistos, nes jo asmens duomenys buvo
                    tvarkomi pažeidžiant Bendrąjį duomenų apsaugos reglamentą.
                  </p>
                  <p>
                    12. Esu informuotas, kad duomenų subjektas, dėl duomenų
                    subjekto teisių pažeidimo patyręs materialinę ar
                    nematerialinę žalą, turi teisę į kompensaciją, dėl kurios
                    priteisimo jis gali kreiptis į teismą teisės aktų nustatyta
                    tvarka.
                  </p>
                  <p>
                    13. Man yra žinoma, kad nepateikus prašomų duomenų, INVEGA
                    gali atsisakyti suteikti prašomas paslaugas, sustabdyti
                    paslaugų teikimą ar keisti paslaugų teikimo sąlygas.
                  </p>

                  {notValid && !agree && (
                    <p className="errors-block-message">
                      Privalote patvirtinti sutikimą
                    </p>
                  )}
                  <input
                    type="checkbox"
                    id="scales"
                    name="scales"
                    checked={agree}
                    onClick={toggleAgree}
                  ></input>
                  <span className="checkmark"></span>
                </label>
              </div>
              <div className="checkbox">
                <label className="containerLabel noBlock">
                  Patvirtinu, kad asmenims, kurių asmens duomenis pateikiu
                  (juridinių asmenų atstovai, darbuotojai, steigėjai,
                  akcininkai, dalyviai, savininkai ir pan.) yra žinoma, kad jų
                  asmens duomenis tvarko INVEGA ir šie asmenys buvo supažindinti
                  su šiuo pranešimu bei INVEGOS{' '}
                  <a
                    href="https://ilte.lt/asmens-duomenu-apsauga/16"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Asmens duomenų tvarkymo taisyklėmis
                  </a>
                  .
                  {notValid && !agree1 && (
                    <p className="errors-block-message">
                      Privalote patvirtinti sutikimą
                    </p>
                  )}
                  <input
                    type="checkbox"
                    id="scales"
                    name="scales"
                    checked={agree1}
                    onClick={() => setAgree1(!agree1)}
                  ></input>
                  <span className="checkmark"></span>
                </label>
              </div>

              <div className="checkbox">
                <label className="containerLabel noBlock">
                  Tuo atveju, kai pateikiu kitų asmenų asmens duomenis, tokių
                  asmenų asmens duomenys yra gauti teisėtai ir kad turiu teisę
                  atskleisti šiuos asmens duomenis INVEGAI.
                  {notValid && !agree2 && (
                    <p className="errors-block-message">
                      Privalote patvirtinti sutikimą
                    </p>
                  )}
                  <input
                    type="checkbox"
                    id="scales"
                    name="scales"
                    checked={agree2}
                    onClick={() => setAgree2(!agree2)}
                  ></input>
                  <span className="checkmark"></span>
                </label>
              </div>

              <div className="checkbox">
                <label className="containerLabel noBlock">
                  Tvirtinu, kad pateikta informacija yra teisinga.
                  {notValid && !agree3 && (
                    <p className="errors-block-message">
                      Privalote patvirtinti sutikimą
                    </p>
                  )}
                  <input
                    type="checkbox"
                    id="scales"
                    name="scales"
                    checked={agree3}
                    onClick={() => setAgree3(!agree3)}
                  ></input>
                  <span className="checkmark"></span>
                </label>
              </div>

              <div className="checkbox">
                <label className="containerLabel noBlock">
                  Sutinku, kad mano asmens duomenys (vardas, pavardė,
                  elektroninio pašto adresas, telefono ryšio numeris) būtų
                  naudojami atliekant pareiškėjų nuomonių apie INVEGOS suteiktų
                  paskolų teisėtumą bei efektyvumą apklausas, rengiant
                  statistines ataskaitas apie suteiktas INVEGOS paskolas.
                  {notValid && !agree4 && (
                    <p className="errors-block-message">
                      Privalote patvirtinti sutikimą
                    </p>
                  )}
                  <input
                    type="checkbox"
                    id="scales"
                    name="scales"
                    checked={agree4}
                    onClick={() => setAgree4(!agree4)}
                  ></input>
                  <span className="checkmark"></span>
                </label>
              </div>

              <div className="checkbox">
                <label className="containerLabel noBlock">
                  Man yra žinoma, kad šiuo tikslu duotą sutikimą tvarkyti mano
                  asmens duomenis, bet kuriuo metu turiu teisę atšaukti, šiais
                  būdais: raštu{' '}
                  <a href="mailto:kontaktu.centras@ilte.lt">
                    kontaktu.centras@ilte.lt
                  </a>{' '}
                  ar telefonu 8 5 210 7510.
                  {notValid && !agree5 && (
                    <p className="errors-block-message">
                      Privalote patvirtinti sutikimą
                    </p>
                  )}
                  <input
                    type="checkbox"
                    id="scales"
                    name="scales"
                    checked={agree5}
                    onClick={() => setAgree5(!agree5)}
                  ></input>
                  <span className="checkmark"></span>
                </label>
              </div>
              <button
                className="btn standart mainconfirmbtn"
                onClick={() => confirm()}
              >
                Tvirtinu, kad pateikta informacija yra teisinga
              </button>
            </div>
            {firstStepPassed || isAgreed ? (
              <Redirect to={config.APP_PATHS.requests} />
            ) : null}
          </div>
        </div>
      </div>
    </WithSpinner>
  );
};

const mapStateToProps = (state) => ({
  dashboardData: state.dashboardState.dashboardData,
  loading: state.dashboardState.isOnSync,
  firstStepPassed: state.dashboardState.firstStepPassed,
  isAgreed: state.dashboardState.isAgreed,
  consentData: state.dashboardState.consentData,
  loginType: state.dashboardState.loginType,
});

export default connect(mapStateToProps)(Main);
